import React from 'react';

class NoMatch extends React.Component {
  constructor(props) {
      super(props);
  }

  render() {
    return (
        <div>          
            Not match
        </div>
         
  );}
}


export default NoMatch;